import {
    SurveyAnswer,
    SurveyAnswerValueRecord,
    SurveyVisibilityConditions,
} from "modules/NewClientSurvey/common/interface"
import { ConditionsOperator, AnswerType } from "modules/NewClientSurvey/common/constants"

export function compareConditions(
    visibilityConditions: SurveyVisibilityConditions[],
    answers: Record<string, SurveyAnswer>
): boolean {
    return visibilityConditions.every((c) => {
        const cValue = c.value.toLowerCase()

        switch (c.operator) {
            case ConditionsOperator.EQUALS:
                return answers[c.precondition_question_id]?.type === AnswerType.choices
                    ? (answers[c.precondition_question_id]?.value as SurveyAnswerValueRecord)[
                          cValue
                      ]
                    : answers[c.precondition_question_id]?.value === cValue
            case ConditionsOperator.IN:
                return answers[c.precondition_question_id]?.type === AnswerType.choices
                    ? (answers[c.precondition_question_id]?.value as SurveyAnswerValueRecord)[
                          cValue
                      ]
                    : String(answers[c.precondition_question_id]?.value)?.indexOf(cValue)
            case ConditionsOperator.NOTEMPTY:
                return answers[c.precondition_question_id]?.value
            default:
                return false
        }
    })
}
